import React from 'react';
import { BringzzIcon } from '@bringzz/components';

const ScanHeader = ({ onBackPress, onFlashToggle, isMobile, isFrontCamera }) => {
    return (
        <div className="absolute top-0 left-0 p-5 flex justify-between w-full z-50">
            <BringzzIcon
                size="16"
                icon="IconClose"
                folder="LineIcons"
                className="cursor-pointer text-white bg-black/80 rounded-full p-3"
                onClick={onBackPress}
            />
            {!isFrontCamera && (
                <BringzzIcon
                    size="24"
                    icon="IconThunderbolt"
                    folder="LineIcons"
                    className="cursor-pointer text-white bg-black/80 rounded-full p-2"
                    onClick={onFlashToggle}
                />
            )}
        </div>
    );
};

export default ScanHeader;
